import { LiveHelpOutlined } from "@mui/icons-material";

const otherInfoResource = {
    title: "Other Information",
    singular: "Other Info",

    collectionField: "otherInfos",

    displayField: "other36a2",

    icon: LiveHelpOutlined,

    columns: [
        {
            field: "other36a2",
            header: "Item 36A",
            type: "text"
        },
        {
            field: "other37a2",
            header: "Item 37A",
            type: "text"
        },
        {
            field: "other38a2",
            header: "Item 38A",
            type: "text"
        }
    ],

    fields: {
        other36a1: {
            name: "other36a1",
            label: "Item 36A (1)",
            type: "number",
            required: true
        },
        other36a2: {
            name: "other36a2",
            label: "Item 36A (2)",
            type: "text",
            required: true
        },
        other36b1: {
            name: "other36b1",
            label: "Item 36B (1)",
            type: "number"
        },
        other36b2: {
            name: "other36b2",
            label: "Item 36B (2)",
            type: "text"
        },
        other37a1: {
            name: "other37a1",
            label: "Item 37A (1)",
            type: "number"
        },
        other37a2: {
            name: "other37a2",
            label: "Item 37A (2)",
            type: "text"
        },
        other37b1: {
            name: "other37b1",
            label: "Item 37B (1)",
            type: "number"
        },
        other37b2: {
            name: "other37b2",
            label: "Item 37B (2)",
            type: "text"
        },
        other38a1: {
            name: "other38a1",
            label: "Item 38A (1)",
            type: "number"
        },
        other38a2: {
            name: "other38a2",
            label: "Item 38A (2)",
            type: "text"
        },
        other39a1: {
            name: "other39a1",
            label: "Item 39A (1)",
            type: "number"
        },
        other39a2: {
            name: "other39a2",
            label: "Item 39A (2)",
            type: "text"
        },
        other40a1: {
            name: "other40a1",
            label: "Item 40A (1)",
            type: "number"
        },
        other40a2: {
            name: "other40a2",
            label: "Item 40A (2)",
            type: "text"
        },
        other41a1: {
            name: "other41a1",
            label: "Item 41A (1)",
            type: "number"
        },
        other41a2: {
            name: "other41a2",
            label: "Item 41A (2)",
            type: "text"
        },
        other41b1: {
            name: "other41b1",
            label: "Item 41B (1)",
            type: "number"
        },
        other41b2: {
            name: "other41b2",
            label: "Item 41B (2)",
            type: "text"
        },
        other41c1: {
            name: "other41c1",
            label: "Item 41C (1)",
            type: "number"
        },
        other41c2: {
            name: "other41c2",
            label: "Item 41C (2)",
            type: "text"
        }
    }
};

export default otherInfoResource;
